/** kg CO2e -> compact tonnes string ("1,284 t"), mono/tabular numerics per
 * the design system's "numbers, IDs, money are always mono" convention.
 *
 * SIL-485 — sub-10t figures render with one decimal ("0.2 t", "5.8 t")
 * instead of rounding to whole tonnes: a real, nonzero Cat 4/11/12 monthly
 * flow (e.g. ~0.15t fleet-wide) rounded to "0t" under the old
 * `Math.round(...)` — indistinguishable from a genuine zero. >=10t keeps the
 * prior whole-tonne display (a matrix/chart of thousand-tonne figures
 * doesn't need decimal noise). */
export function formatTonnes(kgco2e: number | null | undefined): string {
  if (kgco2e === null || kgco2e === undefined || Number.isNaN(kgco2e)) return '—';
  const tonnes = kgco2e / 1000;
  const absTonnes = Math.abs(tonnes);
  if (absTonnes < 10) {
    return `${tonnes.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} t`;
  }
  return `${Math.round(tonnes).toLocaleString('en-US')} t`;
}

/** `period_key` ('YYYY-MM-DD', first-of-month) -> short month label ("Jul
 * 2026"), for the YoY table's row label (SIL-487). Parsed as UTC so the
 * label never shifts a day off the intended month in a behind-UTC
 * timezone. */
export function formatMonthLabel(periodKey: string): string {
  const d = new Date(`${periodKey}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return periodKey;
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
}

/** MWh -> compact string ("142.3 MWh") — SIL-476 monthly overlay. */
export function formatMwh(mwh: number | null | undefined): string {
  if (mwh === null || mwh === undefined || Number.isNaN(mwh)) return '—';
  return `${mwh.toLocaleString('en-US', { maximumFractionDigits: 1 })} MWh`;
}
